const Unpin = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_24833_148503)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.90877 6.44423C6.13862 6.57179 5.26592 6.64315 4.24712 6.64315C4.10106 6.64315 3.95499 6.67124 3.81792 6.72853C3.54265 6.84311 3.32468 7.06216 3.21007 7.33626C3.09659 7.61036 3.09659 7.9204 3.21007 8.1945C3.26738 8.33267 3.3494 8.45736 3.45389 8.56071L7.09759 12.2037L2 19L8.79754 13.9034L12.4401 17.5453C12.5435 17.6509 12.6682 17.7317 12.8064 17.789C12.9435 17.8463 13.0895 17.8766 13.2356 17.8766C13.3817 17.8766 13.5277 17.8463 13.6648 17.789C13.9401 17.6744 14.1592 17.4576 14.2726 17.1813C14.33 17.0454 14.3592 16.8982 14.3592 16.7533C14.3592 15.7346 14.4304 14.862 14.5577 14.0932L6.90877 6.44423ZM16.1498 10.0284C15.9264 10.3207 15.7372 10.6271 15.576 10.9501C15.4285 11.2447 15.2903 11.5493 15.1638 11.8708L9.13337 5.8404C9.46092 5.71277 9.77204 5.57324 10.0739 5.42432C10.3919 5.26535 10.6937 5.07939 10.982 4.86055L16.1498 10.0284ZM17.6032 8.65339C18.0771 8.31698 18.6298 7.99725 19.2759 7.68787C19.4208 7.63282 19.5579 7.55194 19.6736 7.43511C20.1107 6.99364 20.1084 6.28368 19.6691 5.8467L15.1782 1.33083C14.7412 0.891601 14.0311 0.889355 13.5895 1.32634C13.4727 1.44317 13.3918 1.58134 13.3367 1.72513C13.0242 2.37718 12.701 2.93415 12.3608 3.41101L17.6032 8.65339Z"
        fill="#00B4D8"
      />
      <rect
        x="5.42603"
        y="2.13281"
        width="2"
        height="18.452"
        transform="rotate(-45 5.42603 2.13281)"
        fill="#00B4D8"
      />
    </g>
    <defs>
      <clipPath id="clip0_24833_148503">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Unpin;
